import axios from 'axios';
import { url } from 'utils/urls';

const withCredentials = true;

const headers = {
    "Content-Type": "application/json",
    'Accept': 'application/json',
};

export const acyncRequestLabels = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/labels`, { withCredentials });

export const asyncCreateLabel = (accountUUID, labelName) => axios.post(`${url.ppa.accounts}/${accountUUID}/labels`, { labelName }, { withCredentials });

export const asyncUpdateLabel = (labelUUID, labelName) => axios.put(`${url.ppa.url}/v1/labels/${labelUUID}`, { labelName }, { withCredentials });

export const asyncDeleteLabel = (labelUUID) => axios.delete(`${url.ppa.url}/v1/labels/${labelUUID}`, { withCredentials });

export const asyncAttachLabelsToEmbed = (accountUUID, embedUUID, attachedLabelUUIDs) =>
    axios.put(`${url.ppa.embeds}/${embedUUID}/labels`, { attachedLabelUUIDs, newLabelNames: [] }, { withCredentials });
